import { render, staticRenderFns } from "./formInputTextArea.vue?vue&type=template&id=2d0ae8a4&scoped=true&"
import script from "./formInputTextArea.vue?vue&type=script&lang=js&"
export * from "./formInputTextArea.vue?vue&type=script&lang=js&"
import style0 from "./formInputTextArea.vue?vue&type=style&index=0&id=2d0ae8a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0ae8a4",
  null
  
)

export default component.exports